import * as React from 'react'
import { Blob } from "@rails/activestorage";
import { useDropzone } from 'react-dropzone'
import styled from "styled-components"
import { MimeTypes } from '../../types'
import { ActiveStorageController } from '../../controllers'
import { HELPCENTER_FAVICON_FILE_SIZE } from '../../Constants';
import Button from '../Button/Button';
import { useTranslation } from 'react-i18next';
import { Style } from '../../styles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const FaviconContainer = styled.div`
  width: 50px;
  height: 50px;
  background: #f8f8f7;
  max-width: 50px;
  max-height: 50px;
  border: 1px solid ${Style.color.border};
  cursor: pointer;
`
const Favicon = styled.img`
  width: 50px;
  height: 50px;
  max-width: 50px;
  max-height: 50px;
`

interface IProps {
  url: string
  onSubmit: (blob: Blob) => void
}

const FaviconUpload = (props: IProps) => {
  const { t } = useTranslation()
  const { url, onSubmit } = props

  const onDrop = async (acceptedFiles: File[]) => {
    const file = acceptedFiles[0]

    if (file) {
      ActiveStorageController.uploadPublic(file, async (error, blob) => {
        if (error) { console.error(error) }
        if (blob) onSubmit(blob)
      })
    }
  }

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop: onDrop,
    multiple: false,
    accept: [
      MimeTypes.ICO,
      MimeTypes.PNG,
      MimeTypes.SVG,
      MimeTypes.JPEG,
    ],
    maxSize: HELPCENTER_FAVICON_FILE_SIZE,
  })

  const onDeleteClick = () => {
    onSubmit(null)
  }

  return (
    <Container>
      <FaviconContainer {...getRootProps()}>
        {url && <Favicon src={url} />}
      </FaviconContainer>
      <input type='file' {...getInputProps()} />

      {url && <span style={{ marginTop: 16 }}>
        <Button
          type='default'
          text={t('FaviconUploader::Remove this image')}
          icon='trash'
          onClick={onDeleteClick}
        />
      </span>}
    </Container>
  )
}

export default FaviconUpload